import React from "react";
import { Route } from "react-router";
import { Switch } from "react-router-dom";
import { ROUTE } from "../../constants";
import LoginLayout from "./components/LoginLayout";
import LoginForm from "./components/LoginForm";
import UpdatePasswordForm from "./components/UpdatePasswordForm";
import ResetPasswordForm from "./components/ResetPasswordForm";
import SetNewPassword from "./components/SetNewPassword";
export const Logon = () => {
  return /*#__PURE__*/React.createElement(LoginLayout, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: ROUTE.LOGON_PAGE,
    exact: true,
    component: LoginForm
  }), /*#__PURE__*/React.createElement(Route, {
    path: ROUTE.UPDATE_PASSWORD_PAGE,
    exact: true,
    component: UpdatePasswordForm
  }), /*#__PURE__*/React.createElement(Route, {
    path: ROUTE.RESET_PASSWORD_PAGE,
    exact: true,
    component: ResetPasswordForm
  }), /*#__PURE__*/React.createElement(Route, {
    path: ROUTE.SET_NEW_PASSWORD_PAGE,
    exact: true,
    component: SetNewPassword
  })));
};